module.exports = __webpack_public_path__ + "static/media/bar-chart-icon.6113b0c7.svg";